import BookingOverviewComponent from "../components/booking-overview.component";

const BookingOverview = () => {
    return <BookingOverviewComponent />;
  };
  
  export default BookingOverview;